var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suchdoge"},[_c('img',{key:this.url,attrs:{"alt":"A Doge","src":this.url,"width":this.width,"height":this.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }